import {createStore, combineReducers, applyMiddleware, compose} from "redux";
import {apiMiddleware} from "./middlewares/apiMiddleware";
import languageReducer from "./reducers/Languages";
import apiReducer from "./reducers/Api";
import otherReducer from "./reducers/Others";

export const rootReducer = combineReducers({
    languageReducer,
    apiReducer,
    otherReducer
});

export type AppState = ReturnType<typeof rootReducer>

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer, composeEnhancers(
    applyMiddleware(apiMiddleware)));